<!--
 * @Autor: yingna.gao
 * @Date: 2022-08-25 15:35:26
 * @LastEditTime: 2022-08-25 16:36:57
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/components/RcBase/RcInputNumber/RcInputNumber.vue
-->
<template>
  <el-input-number
    ref="rcInputNumber"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  ></el-input-number>
</template>

<script>
export default {
  name: "RcInputNumber",
  props: {
    value: [Number]
  }
};
</script>
